import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import getPromoCodeQuery from './getPromoCode.graphql';
import cx from 'classnames';
import s from './EditPromoCode.css';
import PromoCodeForm from '../../../../components/SiteAdmin/PromoCode/PromoCodeForm';
//meassage
import {  FormattedMessage } from 'react-intl';
import messages from '../../../../locale/messages';

class EditPromoCode extends React.Component {
  static defaultProps = {
    promoCode: {
      loading: true
    }
  };

  render() {
    const { title, promoCode: { loading, getPromoCode } } = this.props;

    let initialValues = {};

    if (!loading && getPromoCode) {
      initialValues = getPromoCode;
    }

    return (
      <div className={s.root}>
        <div className={s.container}>
         <div className={cx(s.heading, 'textAlignRightRTL')}>
          <FormattedMessage {...messages.editPromoCode} />
          </div>
          <div className={s.paddingRoutesSection}>
            {
              !loading && <PromoCodeForm initialValues={initialValues} />
            }
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  withStyles(s),
  graphql(getPromoCodeQuery, {
    name: 'promoCode',
    options: (props) => ({
      ssr: true,
      fetchPolicy: 'network-only',
      variables: {
        id: props.id
      }
    })
  }))(EditPromoCode);